import { render } from "./MeCard.vue?vue&type=template&id=48d790c7&scoped=true"
import script from "./MeCard.vue?vue&type=script&lang=js"
export * from "./MeCard.vue?vue&type=script&lang=js"

import "./MeCard.vue?vue&type=style&index=0&id=48d790c7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d790c7"]])

export default __exports__